import { createPinia } from "pinia";
import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import App from "./App.vue";
import { setUnauthorizedHandler } from "./platform/admin-api.js";
import { router } from "./router/index.js";

import "./styles/app.css";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus);

// 会话失效的统一出口：任何接口返回 401 都会走到这里，界面不会被留在一个
// 「看起来还登录着、其实每次都失败」的状态里。
setUnauthorizedHandler(() => {
  void router.push({ name: "login" });
});

app.mount("#app");
